export const LINKS = {
  whatsapp:
    "https://wa.me/918850159361?text=Hello%20Dr.%20Mugdha%2C%20I%20would%20like%20to%20book%20a%20consultation.",
  instagram: "https://www.instagram.com/drmugdhhashomoeopathy",
  facebook: "https://www.facebook.com/share/1EakWFxt8b/",
  email: "mailto:mugdhaadhikari9594@gmail.com",
  phone: "tel:+918850159361",
};

export const PORTRAITS = {
  hero: "https://customer-assets-agu9un31.emergentagent.net/job_cdae9cff-5cf6-47e9-b9fb-418cf105252c/artifacts/i3uxsmtj_1000822082.jpg.webp",
  desk: "https://customer-assets-agu9un31.emergentagent.net/job_cdae9cff-5cf6-47e9-b9fb-418cf105252c/artifacts/28o6xnjt_IMG20260602114915.jpg.webp",
};

export const TEXTURES = {
  botanical:
    "https://images.unsplash.com/photo-1592296429945-93008c7e5a59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxob21lb3BhdGh5JTIwYm90YW5pY2FsJTIwbWVkaWNpbmUlMjBsZWF2ZXMlMjBjbGluaWMlMjBjYWxtJTIwbWluaW1hbHxlbnwwfHx8fDE3OTA2OTgwNjl8MA&ixlib=rb-4.1.0&q=85",
};

export const NAV_ITEMS = [
  { label: "PRACTICE", id: "practice" },
  { label: "EXPERIENCE", id: "experience" },
  { label: "ETHOS", id: "ethos" },
  { label: "ACADEMICS", id: "academics" },
  { label: "REVIEWS", id: "reviews" },
  { label: "BLOG", id: "blog" },
  { label: "CONTACT", id: "contact" },
];

export const STATS = [
  { value: "7+", label: "YEARS IN PRACTICE" },
  { value: "02", label: "DEGREES · MD + BHMS" },
  { value: "05", label: "HOSPITALS SERVED" },
  { value: "2019", label: "PRACTISING SINCE" },
];

export const MARQUEE_ITEMS = [
  "HOMOEOPATHIC MATERIA MEDICA",
  "GENTLE CURE",
  "NUTRITION & LIFESTYLE",
  "INDIVIDUALISED CARE",
  "TELE-HOMOEOPATHY",
  "KANDIVALI WEST · MUMBAI",
];

export const CHANNELS = [
  {
    title: "IN-CLINIC CONSULTATION",
    desc: "Gentle Cure Homoeoclinic — detailed case-taking and follow-ups at the Kandivali West clinic.",
    meta: "KANDIVALI W, MUMBAI",
    tag: "OFFLINE",
  },
  {
    title: "TELE-HOMOEOPATHY",
    desc: "Full online consultations over video — case history, remedy selection and couriered medicines.",
    meta: "WORLDWIDE",
    tag: "ONLINE",
  },
  {
    title: "NUTRITION & LIFESTYLE",
    desc: "Holistic nutrition coaching for hormonal health, PCOS, weight and long-term immunity.",
    meta: "SINCE 2023",
    tag: "COACHING",
  },
];

export const EXPERIENCE = [
  {
    years: "2026 — PRES",
    org: "SSO CANCER HOSPITAL",
    role: "RMO Incharge — leading ward care and integrative oncology support, Andheri West.",
    type: "HOSPITAL",
  },
  {
    years: "2021 — PRES",
    org: "GENTLE CURE HOMOEOCLINIC",
    role: "Founder & consulting homoeopathic physician — offline and online practice.",
    type: "CLINIC",
  },
  {
    years: "2025 — 2026",
    org: "BORIVALI HEALTH CARE HOSPITAL",
    role: "Resident Medical Officer — ward medicine and inpatient management.",
    type: "HOSPITAL",
  },
  {
    years: "2023 — 2025",
    org: "INDEPENDENT PRACTICE",
    role: "Holistic nutrition & lifestyle consultant — hormonal health and metabolic care.",
    type: "NUTRITION",
  },
  {
    years: "2022 — 2025",
    org: "PHOENIX · CHILDREN'S · SHREE GANESHA",
    role: "Locum physician across hospitals in Borivali, Kandivali & Malad.",
    type: "LOCUM",
  },
  {
    years: "2021",
    org: "TMC — THANE MUNICIPAL CORPORATION",
    role: "COVID warrior — six months of frontline medical duty during the pandemic.",
    type: "PUBLIC HEALTH",
  },
];

export const TENETS = [
  {
    num: "01",
    title: "SIMILIA SIMILIBUS CURENTUR",
    desc: "\u201CLike cures like\u201D — the foundational law. Every remedy is matched precisely to the individual's totality of symptoms.",
  },
  {
    num: "02",
    title: "THE MINIMUM DOSE",
    desc: "Gentle, nano-scale medicines that nudge the body to heal itself — no suppression, no harsh side effects.",
  },
  {
    num: "03",
    title: "MIND–BODY TOTALITY",
    desc: "Every case is heard in full — emotions, sleep, cravings, stress — before a single remedy is chosen.",
  },
  {
    num: "04",
    title: "ROOT-CAUSE IMMUNITY",
    desc: "Building long-term resilience season after season, instead of chasing symptoms every few weeks.",
  },
];

export const DEGREES = [
  {
    degree: "MD — HOMOEOPATHIC MATERIA MEDICA",
    institution: "Kakasaheb Mhaske Homoeopathic Medical College & PG Institute",
    location: "AHILYANAGAR, MAHARASHTRA",
    year: "2024",
  },
  {
    degree: "BHMS — BACHELOR OF HOMOEOPATHIC MEDICINE & SURGERY",
    institution: "Smt. Chandaben Mohanbhai Patel Homoeopathic Medical College",
    location: "VILE PARLE, MUMBAI",
    year: "2020",
  },
  {
    degree: "HSC — SCIENCE",
    institution: "SS & LS Patkar College of Science & Arts",
    location: "MUMBAI",
    year: "2014",
  },
  {
    degree: "SSC",
    institution: "Oxford Public School",
    location: "MUMBAI",
    year: "2012",
  },
];

export const REVIEW_IMAGES = [
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_homeo-doctor-ai/artifacts/hyuzzzgk_Screenshot%202026-09-29%20204741.png",
    author: "UJALA PRASAD",
    caption: "★★★★★ · GOOGLE REVIEW · 3 YEARS AGO",
    alt: "Google review by Ujala Prasad praising Dr. Mugdha Adhikari for curing her mother's cold allergy and breathing problem",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_homeo-doctor-ai/artifacts/cxk422bb_Screenshot%202026-09-29%20205114.png",
    author: "SONALI PRASAD",
    caption: "★★★★★ · GOOGLE REVIEW · 2 YEARS AGO",
    alt: "Google review by Sonali Prasad about her two-year breathing issue improving without a pump after Dr. Mugdha's treatment",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_homeo-doctor-ai/artifacts/bq1hwnio_Screenshot%202026-09-29%20205221.png",
    author: "PRATHAMESH PANCHAL",
    caption: "★★★★★ · GOOGLE REVIEW · 3 YEARS AGO",
    alt: "Google review by Prathamesh Panchal describing Dr. Mugdha's accurate diagnosis and 24x7 guidance during COVID times",
  },
];

export const REVIEW_CARDS = [
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_homeo-doctor-ai/artifacts/2k1t42bd_Screenshot_2026-09-29-20-47-01-95_1c337646f29875672b5a61192b9010f9.jpg.jpeg",
    caption: "★★★★★ · PATIENT REVIEW · MIGRAINE CARE",
    alt: "Patient review — migraine of 2-3 years under control after treatment from Dr. Mugdha",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_homeo-doctor-ai/artifacts/84mnfwo9_Screenshot_2026-09-29-20-47-24-58_1c337646f29875672b5a61192b9010f9.jpg.jpeg",
    caption: "★★★★★ · PATIENT REVIEW · ASTHMA & IMMUNITY",
    alt: "Patient review — asthma, cough and immunity improved within three months of treatment with Dr. Mugdha Adhikari",
  },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
